import React from 'react';
import './CertificateCard.css'; // Import the CSS file for styling

const CertificateCard = ({ image, title, link }) => {
  return (
    <div className="certificate-card">
      <img src={image} alt={title} className="certificate-card-image" style={{ height: '200px' ,width:'400px'}}/>
      <div className="certificate-card-content">
        <h3 className="certificate-card-title">{title}</h3>
        <a href={link} className="certificate-card-link" target="_blank" rel="noopener noreferrer">
          View Certificate
        </a>
      </div>
    </div>
  );
};

export default CertificateCard;
